import { AUTHOR_LOGIN, AUTHOR_LOGOUT } from "../types/type";

const initState = {
    authorToken: '',
    isAuthor: false
}

const AuthorReducer = (state = initState, action) => {
    switch (action.type) {
        case AUTHOR_LOGIN:
            return {
                ...state,
                authorToken: action.payload,
                isAuthor: true
            }

        case AUTHOR_LOGOUT:
            return {
                ...state,
                authorToken: "",
                isAuthor: false
            }

        default:
            return state;
    }
}

export default AuthorReducer;